// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC8AJnMFsSaX2neafEy3WHCBzfW9rtxyGI",
  authDomain: "alphaleaf-login.firebaseapp.com",
  databaseURL: "https://alphaleaf-login.firebaseio.com",
  projectId: "alphaleaf-login",
  storageBucket: "alphaleaf-login.appspot.com",
  messagingSenderId: "627722815455",
  appId: "1:627722815455:web:b6f8b9518c3e866030a66a",
  measurementId: "G-YXN2RLZ39H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
getAnalytics(app);
const auth = getAuth();
const db = getFirestore();

export { auth, db };

// Firebase Exports
// export const db = getFirestore();
// export const auth = getAuth();
